import { type RestartPreview } from "@vidario/domain";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { useVidarioClient } from "../client";
import { queryKeys } from "../queryKeys";

/** Admin-only: what a Search restart would delete (#18). Fetched fresh each
 * time the restart dialog opens, so the counts match what gets purged. */
export function useRestartPreview(
  jobId: string,
  options?: { enabled?: boolean },
): UseQueryResult<RestartPreview> {
  const client = useVidarioClient();
  return useQuery({
    queryKey: queryKeys.restartPreview(jobId),
    queryFn: () => client.getRestartPreview(jobId),
    enabled: (options?.enabled ?? true) && Boolean(jobId),
    staleTime: 0,
  });
}
